import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const DeleteConversationPopup = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-text-primary/40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-background shadow-md p-10 rounded-lg max-w-md w-full relative z-60">
        <h2 className="text-xl font-bold mb-4 text-text-primary">{t('deleteConversationPopup.title')}</h2>
        <p className="mb-6 text-text-secondary">{t('deleteConversationPopup.message')}</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-neutral-200 rounded hover:bg-neutral-300 transition-colors"
          >
            {t('deleteConversationPopup.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-error text-white rounded hover:bg-error-600 transition-colors"
          >
            {t('deleteConversationPopup.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConversationPopup;
